// extracted by mini-css-extract-plugin
export default {"root":"InfoItem_root__CiM6Z","label":"InfoItem_label__VJpDS","value":"InfoItem_value__PgEew"};